import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { utilIsNil } from '../../service/library/library';

@Injectable({
  providedIn: 'root'
})
export class tdrsBusService {
  private readonly _bus: Subject<any> = new Subject<any>();

  constructor() {
  }
  /**
   * Dispat
   * ch()
   */
  public dispatch(message: any) {
    if (!utilIsNil(message)) {
      this._bus.next(message);
    }
  }
  /**
   * message()
   */
  public message(): Observable<any> {
    return this._bus.asObservable();
  }
}
